import * as tslib_1 from "tslib";
/** @jsx jsx */
/** Do not edit this file directly. Edit the template in scripts/icon-template.ejs **/
import { jsx } from "@emotion/core";
import PropTypes from "prop-types";
import { useTheme } from "../../Theme/Providers";
export var IconHeart = function (_a) {
    var providedColor = _a.color, _b = _a.size, providedSize = _b === void 0 ? "md" : _b, other = tslib_1.__rest(_a, ["color", "size"]);
    var theme = useTheme();
    var size = typeof providedSize === "string"
        ? theme.iconSizes[providedSize]
        : providedSize;
    var color = providedColor || theme.colors.text.default;
    return (jsx("svg", tslib_1.__assign({ viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", height: size, width: size }, other),
        jsx("path", { d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" })));
};
IconHeart.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
